import type { components } from "@/api-schema";
import { OccupationIdentifierSystem } from "@/api-schema-enums";
import { normalizePositiveSafeIntegerIdentifier } from "@/common/helpers/normalize-numeric-identifier";

type Occupation = Pick<components["schemas"]["Occupation"], "occupationIdentifiers">;
type OccupationIdentifierDto = components["schemas"]["OccupationIdentifierDto"];

export function getOccupationV1Identifier(occupation: Occupation): string | undefined {
  return occupation.occupationIdentifiers?.find((identifier) => identifier.type === OccupationIdentifierSystem.V1)
    ?.identifier;
}

export function toOccupationIdentifierDtos(v1Identifier: string): OccupationIdentifierDto[] {
  const normalizedIdentifier = normalizePositiveSafeIntegerIdentifier(v1Identifier);
  return normalizedIdentifier === undefined
    ? []
    : [{ type: OccupationIdentifierSystem.V1, identifier: normalizedIdentifier }];
}
